import React, { createContext, useContext, useState } from "react";
import { defaultSeatSearch } from "../pages/TabPages/FilterComponents/DefaultSeatValues";

const SeatSearchContext = createContext();
export const SeatSearchProvider = ({ children }) => {
  //Set Initial Values
  const initialValues = defaultSeatSearch
  const [seatSearchArray, setSeatSearchArray] = useState(initialValues);
    
  const updateSeatSearchArray = (values) => {
    console.log(values)
    setSeatSearchArray(values);
  };

  return (
    <SeatSearchContext.Provider value={{ seatSearchArray, updateSeatSearchArray }}>
      {children}
    </SeatSearchContext.Provider>
  );
};

// Custom hook to access the context
export const useSeatSearchContext = () => useContext(SeatSearchContext);

